// 导出函数 getUUID() 用于生成 uuid

import { v4 as uuidv4 } from 'uuid'

// export const getUUID = function () {
//   // 将 uuid 存储与浏览器中 避免每次产生新id
//   let uuid = localStorage.getItem('uuid')

//   if (!uuid) {
//     uuid = uuidv4()
//     localStorage.setItem('uuid', uuid)
//   }

//   return uuid
// }
export const getUUID = function () {
  // 生成一个唯一的ID，可以根据需要调整字符串的长度
  let uuid = localStorage.getItem('uuid')

  if (!uuid) {
    let oneuuid = Date.now().toString(36)
    let twouuid = Math.random().toString(36).substring(2, 9)
    // console.log(oneuuid, twouuid, 'oneuuid')
    uuid = oneuuid + twouuid
    localStorage.setItem('uuid', uuid)
  }

  return uuid
}



// WEBPACK FOOTER //
// ./src/utils/uuid_token.js